
import React from 'react';
import { Task } from '@/types/tasks';
import { useAuth } from '@/contexts/auth';

interface TaskAddHandlerProps {
  onAddTask?: (taskData: Omit<Task, 'id' | 'isCompleted' | 'createdAt'>) => void;
}

const TaskAddHandler: React.FC<TaskAddHandlerProps> = ({ onAddTask }) => {
  const { user } = useAuth(); // Now uses centralized auth context

  // Function to add a new task
  const addTask = (taskData: Omit<Task, 'id' | 'isCompleted' | 'createdAt'>) => {
    if (!user) {
      console.error("User not authenticated (centralized auth)");
      return;
    }
    
    // Use only the parent's onAddTask callback - no global context
    if (onAddTask) {
      onAddTask(taskData);
    }
  };

  return null; // This is a non-visual component that just provides functionality
};

export default TaskAddHandler;
